import { customizedUIBlockerStyle } from './customize-ui-blocker-style';

export const getDialogImageExtensionStyle = (components, { palette }) => (
  {
    labelContainer: {
      display: 'flex',
      alignItems: 'flex-start',
    },
    description: {
      paddingBottom: 5,
    },
    container: {
      ...components.reactUIBlockerStyle(palette),
      ...customizedUIBlockerStyle,
    },
  }
);
